import React from 'react';

export default function UnifiedLoadingHeads({ styles, text = 'Loading...' }) {
  return (
    <div style={{ ...styles.loadingHeadsWrap, display: 'flex', alignItems: 'center', gap: 8 }}>
      <span className="spinner" style={{ width: 16, height: 16, border: '2px solid #0f5bd7', borderTop: '2px solid #fff', borderRadius: '50%', display: 'inline-block', animation: 'spin 1s linear infinite' }} />
      <span style={styles.loadingHeadsText}>{text}</span>
      <style>{`@keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
